import type { IBeneficiaryCard } from './BeneficiaryCard.helpers';
import DefaultCard from './components/Default';
import DeleteCard from './components/Delete';

const BeneficiaryCard = ({
	name,
	bankName,
	accountNumber,
	onClick,
	selected,
	isDeleteMode,
	isAutoSettlement,
	multiple,
	disabled,
}: IBeneficiaryCard) => {
	const CardComponent = isDeleteMode ? DeleteCard : DefaultCard;
	return (
		<CardComponent
			bankName={bankName}
			accountNumber={accountNumber}
			name={name}
			isDeleteMode={isDeleteMode}
			onClick={onClick}
			selected={selected}
			isAutoSettlement={isAutoSettlement}
			multiple={multiple}
			disabled={disabled}
		/>
	);
};

export default BeneficiaryCard;
